import { getDocuments, postDocument } from "../../utils/apiFunctions.js";
export default {
  props: {
    isLaptop: Boolean,
  },
  methods: {
    async getAllDocs() {
      try {
        this.LoaderStatus = true;
        const response = await getDocuments();
        if (response.status === 200) {
          this.shimmerLoader = false;
          this.LoaderStatus = false;
          this.documents = response.data.data;
          if (this.selectedIndex >= 0 && !this.isLaptop) {
            this.allDocs = this.documents[this.selectedIndex];
          }
          if (this.isLaptop) {
            if (this.documents.length === 0) {
              this.noDocsToPreview = true;
            } else {
              this.noDocsToPreview = false;
              this.previewFirstDoc();
            }
          }
        }
      } catch (error) {
        this.shimmerLoader = false;
        throw error;
      }
    },
    previewFirstDoc() {
      let isSelected = false;
      let selectedCategoryIndex =
        this.selectedCategoryIndex !== null ? this.selectedCategoryIndex : null;
      for (let i in this.documents) {
        this.documents[i].openModal = false;
        if (this.documents[i].documents.length !== 0) {
          for (let j in this.documents[i].documents) {
            this.documents[i].documents[j].defineDocPreview = false;
            if (this.documents[i].documents[j].isUploaded && !isSelected) {
              this.previewDoc(this.documents[i].documents[j], i, j);
              isSelected = true;
              if (this.someAction && this.selectedCategoryIndex === null) {
                selectedCategoryIndex = this.deletedIndex;
              } else if (
                !this.someAction &&
                this.selectedCategoryIndex === null
              ) {
                selectedCategoryIndex = i;
              }
            }
          }
        }
        if (!isSelected && this.documents[i].otherDocuments.length !== 0) {
          for (let j in this.documents[i].otherDocuments) {
            this.documents[i].otherDocuments[j].otherDocPreview = false;
            if (!isSelected) {
              this.previewOtherDoc(this.documents[i].otherDocuments[j], i, j);
              isSelected = true;
              if (this.someAction && this.selectedCategoryIndex === null) {
                selectedCategoryIndex = this.deletedIndex;
              } else if (
                !this.someAction &&
                this.selectedCategoryIndex === null
              ) {
                selectedCategoryIndex = i;
              }
            }
          }
        }
      }
      if (selectedCategoryIndex !== null) {
        this.toggleModal(
          selectedCategoryIndex,
          this.documents[selectedCategoryIndex]
        );
        this.selectedCategoryIndex = null;
      }
    },
    previewOtherDoc(data, index, index1) {
      this.resetPreviews();
      this.documents[index].otherDocuments[index1].otherDocPreview = true;
      this.docIndex = index;
      this.info = false;
      this.previewDocs = true;
      this.pdfLink.link = data.documentSource[0];
      this.pdfLink.name = data.documentName;
      this.replaceName = data.documentName;
      this.documentID = data.documentID;
      this.$forceUpdate();
    },
    previewDoc(data, index, index1) {
      this.resetPreviews();
      this.documents[index].documents[index1].defineDocPreview = true;
      this.docIndex = index;
      this.info = false;
      this.previewDocs = true;
      this.pdfLink.link = data.document.documentSource[0];
      this.pdfLink.name = data.documentName;
      this.replaceName = data.documentName;
      this.documentID = data.document.documentID;
      this.$forceUpdate();
    },
    resetPreviews() {
      for (let i in this.documents) {
        for (let j in this.documents[i].documents) {
          this.documents[i].documents[j].defineDocPreview = false;
        }
        for (let j in this.documents[i].otherDocuments) {
          this.documents[i].otherDocuments[j].otherDocPreview = false;
        }
      }
      this.scrollToTop();
      this.currentPage = 1
    },
    toggleModal(index, docs) {
      this.someAction = false;
      for (let i in this.documents) {
        if (i != index) this.documents[i].openModal = false;
      }

      // Toggle the current modal
      this.documents[index].openModal = !this.documents[index].openModal;


      if (this.documents[index].openModal) {
        let hasPreviewedDoc = false;

        // Check predefined documents
        for (let i in docs.documents) {
          docs.documents[i].defineDocPreview = false;
          if (docs.documents[i].isUploaded && !hasPreviewedDoc) {
            this.previewDoc(docs.documents[i], index, i);

            hasPreviewedDoc = true;
          }
        }

        // Check other documents if no predefined documents are uploaded
        if (!hasPreviewedDoc) {
          for (let j in docs.otherDocuments) {
            docs.otherDocuments[j].otherDocPreview = false;
            if (!hasPreviewedDoc) {
              this.previewOtherDoc(docs.otherDocuments[j], index, j);

              hasPreviewedDoc = true;
            }
          }
        }

        if (!hasPreviewedDoc) {
          this.noDocsToPreview = true; 
        } else {
          this.noDocsToPreview = false;
        }
      } else {
        for (let i in docs.documents) {
          docs.documents[i].defineDocPreview = false;
        }
        for (let j in docs.otherDocuments) {
          docs.otherDocuments[j].otherDocPreview = false;
        }
        this.noDocsToPreview = false;
      }

      // Check if all modals are closed
      let allModalsClosed = true;
      for (let i in this.documents) {
        if (this.documents[i].openModal) {
          allModalsClosed = false;
          break;
        }
      }
      this.noModalsOpen = allModalsClosed;

      this.$forceUpdate();
    },

    async updateDoc() {
      await this.getAllDocs();
      let document = this.documents[this.selectedIndex];
      let data = {
        document: document,
        selectedIndex: this.selectedIndex,
      };
      this.$emit("update-doc", data);
    },

    downloadDoc(pdfLink) {
      const link = document.createElement("a");
      link.href = pdfLink;
      link.download = pdfLink.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.info = false;
      this.selectedOption = "";
    },
    openOtherDocumentModal(docs, index) {
      this.docIndex = index;
      this.otherModal = true;
      this.$bvModal.show("candidateUploadDocuments");
      this.defineDocName = "";
      this.categoryID = docs.categoryID;
    },
    replaceDoc() {
      this.otherModal = false;
      this.defineDocName = this.pdfLink.name;
      this.$bvModal.show("candidateUploadDocuments");
      this.info = false;
    },
    deleteDoc(docID) {
      if (docID) {
        this.info = false;
        this.documentID = docID;
        this.$bvModal.show("deleteModal-uld");
      }
    },
    toggleInfo() {
      this.selectedOption = "";
      this.info = !this.info;
      this.$forceUpdate();
    },
    closeToggleInfo(){
      this.info = false;
    },
    selectOption(option) {
      this.selectedOption = option;
    },

    goBack() {
      this.preview = false;
    },
    formatDate(dateString) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      const formattedDate = new Date(dateString).toLocaleDateString(
        undefined,
        options
      );
      return formattedDate;
    },
    async uploadDocs() {
      try {
        if (!this.selectedFile) {
          this.errorModal("Error", "No file selected");
          return;
        }
        const form = new FormData();
        const source = {
          sourceKeys: ["key"],
        };

        form.append("documentName", this.selectedFileName);
        form.append("source", JSON.stringify(source));
        form.append("key", this.selectedFile);
        form.append("tag", true);
        form.append("referenceID", this.defineDocReferenceID);

        const response = await postDocument(form);
        if (response.status === 200) {
          this.shimmerLoader = false;
          this.loaderStatus = false;
          this.$bvModal.hide("candidateUploadDocuments");
          this.successModal("Success", "Document uploaded successfully!");

          await this.getAllDocs();
          if (this.isLaptop) {
            let found = false;
            for (let i in this.documents) {
              for (let j in this.documents[i].documents) {
                if (
                  this.documents[i].documents[j].referenceID ===
                  this.defineDocReferenceID
                ) {
                  this.previewDoc(this.documents[i].documents[j], i, j);
                  found = true;
                  break;
                }
              }
              if (found) break;
            }
          }

          if (!this.isLaptop) {
            this.updateDoc();
          }
          this.$forceUpdate();

          this.selectedFile = null;
          this.selectedFileName = "";
          this.defineDocName = "";
        }
      } catch (error) {
        this.shimmerLoader = false;
        throw error;
      }
    },
  },
};
